var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThunderBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36156 5.12954H5.92987L6.66199 0.699594C6.76658 0.0667448 5.90372 -0.24968 5.51151 0.237127L0.125186 6.9794C-0.18858 7.36885 0.125186 7.95302 0.64813 7.95302H3.07982L2.32155 12.383C2.21696 13.0158 3.07982 13.3322 3.47203 12.8454L8.85835 6.10315C9.19827 5.68937 8.8845 5.12954 8.36156 5.12954Z",
    fill: "#2688E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderBlue);
export default __webpack_public_path__ + "static/media/thunder_blue.e9ed3a7b5f96fdfbe4a2433517ef9698.svg";
export { ForwardRef as ReactComponent };